<template>
    <div class="body">
        <p class="font1" style="padding-top: 8vh;">
            📚 书籍是通向智慧的钥匙，让我们在知识的海洋中遨游，发现更好的自己！
        </p>
    
        <div class="wrapper">
            <div v-for="(book, index) in books" :key="index" class="book-card">
                <div class="inline-row">
                    <input type="checkbox" :value="book.title" v-model="selectedCourses" />
                    <strong>{{ book.title }}</strong>
                </div>
                <div class="book-info">
                    <p class="book-author" style="text-align: center;">{{ book.author }}</p>
                    <div class="book-desc" v-html="book.description"></div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      ReportData: {
        type: Object,
        required: false
      },
      selected: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selectedCourses: [],
        books: [
          {
            title: '彼得2.0',
            author: '彼得:斯科特-摩根(Peter Scott-Morgan)',
            description: `本书是一位科学家挑战命运的真实故事。作者彼得是一位机器人专家，在被诊断出患有肌萎缩性脊髓侧素硬化症(ALS)后，没有选择等待死亡，而是启动了一个前所未有的“人类升级”计划。他借助人工智能、眼动仪、声音合成器与机器人等技术，将自己的身体和意识逐步“重构”为一个具备高度自主与表达能力的“人类赛博格”。`,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=54990'
          },
          {
            title: '虚拟人',
            author: '玛蒂娜·罗斯布拉特(Martine Rothblatt)',
            description: `本书以作者哲学家与科技领导者的视角，探讨了“数字永生”这一前沿话题。她提出，通过构建“心智档案”(Mindfile)与“心智软件”(Mindware)，人类的记忆、性格与思想将有可能被复制成“心智克隆人”。`,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=53931'
          }
        ]
      };
    },
    watch: {
      selectedCourses: {
        deep: true,
        handler(newVal) {
          this.$emit('update:selected', newVal);
        }
      }
    },
    mounted() {
      this.selectedCourses = [...this.selected];
    },
  };
  </script>
  <style scoped>
  .body {
      background: 
      url("../../assets/25Auguest/logo.png") right  top  no-repeat,
      url("../../assets/25Auguest/bg.jpg")  no-repeat;
      background-size:100% 100%,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 96%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #528ce8;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #36854f;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .wrapper {
      width: 94%;
      text-align: justify;
      margin: 0 auto;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  .inline-row {
    display: flex;
    align-items: center;     /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    gap: 8px;                /* 他们之间间距 */
    width: 100%;     
    color: #36854f;  
    padding-top: 10px;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Auguest/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font1{
    text-align: center;
  }
  .wrapper {
      width: 80%;
      text-align: justify;
      margin: 0 auto;
      font-size: 18px;
      /* border-radius: 10px; */
      /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  }
}
</style>